export default __webpack_public_path__ + "static/media/success.5dd64e8b.svg";